define(function(require, exports, module) {
	var DomainFolders, config, api, domainFolders;

	DomainFolders = require('./DomainFolder');
	config = require('Cloud/config');
	api = require('Cloud/Application/api');

	domainFolders = new DomainFolders({
		enabled: !!config.get('B2B_BIZ_USER') && !(config.get('PUBLIC') || config.get('STATIC') || config.get('IS_BLOCKED')),
		api: api
	});

	module.exports = domainFolders;
});
